import { render, staticRenderFns } from "./codCollection_closure.vue?vue&type=template&id=92b73180&"
import script from "./codCollection_closure.vue?vue&type=script&lang=js&"
export * from "./codCollection_closure.vue?vue&type=script&lang=js&"
import style0 from "./codCollection_closure.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports